import './assets/Layout.css';const n = "_label_3nayl_17", _ = "_description_3nayl_28", l = "_input_3nayl_20", o = "_loading_3nayl_83", a = "_readonly_3nayl_103", s = "_errored_3nayl_110", e = "_disabled_3nayl_113", t = "_prefix_3nayl_130", i = "_suffix_3nayl_131", r = "_message_3nayl_166", y = {
  "form-field-layout": "_form-field-layout_3nayl_9",
  label: n,
  "input-layout": "_input-layout_3nayl_20",
  "input-list": "_input-list_3nayl_21",
  "component-slot": "_component-slot_3nayl_25",
  description: _,
  input: l,
  loading: o,
  readonly: a,
  errored: s,
  disabled: e,
  "action-suffix": "_action-suffix_3nayl_122",
  prefix: t,
  suffix: i,
  "error-msg": "_error-msg_3nayl_165",
  message: r
};
export {
  y as s
};
